import * as React from 'react';
import {useState, useEffect, useRef} from 'react';
import {Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Flex, Text, Image, SquareProps, Card, SemanticToken} from '@chakra-ui/react';
import { ICustomer } from '../../../../interfaces/jobsheets/ICustomer';
import * as webHelpers from "../../../../helpers/WebHelpers";
import AcceptedCardImage from "../../../../assets/cards.png";
import AcceptedCardImage2 from "../../../../assets/card_image5.png";
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { Payment } from 'square';
import { Card as CardObject} from 'square'; //name Card is already used so importerd as CardObject
//import { TokenResult } from 'square'; 
import { Client, Environment, ApiError } from 'square';
import SquareTokenizeForm from '../tokenize';

interface ISquareProps {
    amount: number
    billingContact: ICustomer | null
    callback: () => void
}

const square = window.Square;

export default function SquarePaymentForm(props: ISquareProps) {
    const amount = useRef(props.amount);
    const sendDataToGTM = useGTMDispatch();
    const [previousPayment, setPreviousPayment] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [isInProgress, setIsInProgress] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");

    const appId = "sq0idp-hYkN_vRN7_Q8QsQpwVSPhw";
    //const appId = 'sandbox-sq0idb-yCbXhfB7FMW6DfrrTQUvKw'; //Sandbox
    const locationId = "LV18QEZ0BJXWP";
    //const locationId = 'LVW97TX91JNEG'; //Sandbox

    //used to be a ts-ignore here
    async function initializeCard(payments:Payment): Promise<CardObject> { //used to import payments object
        const card = await square.payments(appId,locationId).card();

        //Get rid of any old card containers
        const elm = document.getElementById('card-container');
        if (elm) {
            elm.innerHTML = "";
        }

        await card.attach("#card-container");
        console.log("card to be returned is ", card);
        return card;
    }

    // verificationToken can be undefined, as it does not apply to all payment methods.
    //used to be a ts-ignore here 
    async function createPayment(token:string, verificationToken?:string): Promise<void> {
        console.log("Taking payment" + amount.current);
        const bodyParameters = {
            amount: amount.current,
            name: props.billingContact?.Billing.Contact.LastName,
            locationId,
            sourceId: token,
            verificationToken: ""
        };

        if (verificationToken !== undefined) {
            bodyParameters.verificationToken = verificationToken;
        }

        //const body = JSON.stringify(bodyParameters);
        //console.log("bodyParameters", bodyParameters);
        let response = await webHelpers.postAsync("/api/payment/take/new", bodyParameters);

        console.log("square response" , response);
    }

    //used to be a ts-ignore here 
    async function tokenize(paymentMethod:any):Promise<string> { //set return type
        
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === "OK") {
            return tokenResult.token;
        } else {
            throw new Error(
                `Tokenization errors: ${JSON.stringify(tokenResult.errors)}`
            );
        }
    }

    // status is either SUCCESS or FAILURE;
    //used to be a ts-ignore here
    function displayPaymentResults(status:string) {
        if (status === "SUCCESS") {
            setIsError(false);
            setIsSuccess(true);
        } else {
            setIsSuccess(false);
            setIsError(true);
            setErrorMsg("Payment unsuccessful")
        }

        setIsInProgress(false);
    }

    //used to be a ts ignore here
    async function verifyBuyer(payments:any, token:string) {
        console.log(amount.current);
        console.log(props.billingContact?.Billing);
        const verificationDetails = {
            amount: amount.current.toString(),
            billingContact: {
                addressLines: [
                    props.billingContact?.Billing.Address.line1 ?? "",
                    props.billingContact?.Billing.Address.line2 ?? "",
                    props.billingContact?.Billing.Address.line3 ?? "",
                    props.billingContact?.Billing.Address.line4 ?? "",
                    props.billingContact?.Billing.Address.post_code ?? ""
                ],
                familyName: props.billingContact?.Billing.Contact.LastName,
                givenName: props.billingContact?.Billing.Contact.FirstName,
                email: props.billingContact?.Billing.Contact.EmailAddress,
                phone: props.billingContact?.Billing.Contact.MobileNumber == undefined ? props.billingContact?.Billing.Contact.LandLine : props.billingContact?.Billing.Contact.MobileNumber
            },
            currencyCode: "GBP",
            intent: "CHARGE",
        };

        const verificationResults = await payments.verifyBuyer(
            token,
            verificationDetails
        );
        return verificationResults.token;
    }
    
    async function buildForm() {
        if (!square) {
            throw new Error("Square.js failed to load properly");
        }
        let payments: Payment;
        let card:CardObject;
        
        try {
            //used to be a ts-ignore here 
            payments = square.payments(appId, locationId); //appId = the appId of square developer application, found in square developer dashboard
            //const payments2 = Square.payments(appId,locationId);
            
            //locationId = ID of the seller location where the payment is taken, is required to accept Apple Pay, Google Pay, ACH and Cash App payments
            console.log("payments = ",(payments));
            if (payments !== null){
                try {
                card = await initializeCard(payments); //used to use payments as a parameter
              } catch (e) {
                 console.error("Initializing Card failed", e);
              }
             }  
        } catch { //if the program can't create a proper payment then this code will let the user know
            const statusContainer = document.getElementById("payment-status-container");
            if (statusContainer?.className != null)
            {
                (statusContainer.className) = "missing-credentials";
            }
            if (statusContainer?.style.visibility != null)
            {
            statusContainer.style.visibility = "visible";
            }
        }
        
        
        
        async function handlePaymentMethodSubmission(
            
            event: MouseEvent,
            paymentMethod:CardObject,
            shouldVerify = false
        ) {
            event.preventDefault();
            setIsError(false);
            setIsSuccess(false);
            setIsInProgress(true);

            try {
                // disable the submit button as we await tokenization and make a payment request.
                //used to be  a ts ignore here
                if (cardButton != null){
                ((cardButton) as HTMLButtonElement).disabled = true;
                //(document.getElementById('BenchForcastId_'+cardButton) as HTMLButtonElement).disabled = true;
                }

                const token:string = await tokenize(paymentMethod);
                let verificationToken:string;

                if (shouldVerify) {
                    //used to be a ts ignore here 
                    verificationToken= await verifyBuyer(payments, token);
                    console.log("verif token", verificationToken);
                    await createPayment(token, verificationToken);
                    
                }
                else{
                    await createPayment(token);
                
                }
                setPreviousPayment(amount.current);

                displayPaymentResults("SUCCESS");
                if ( cardButton != null ){
                ((cardButton) as HTMLButtonElement).disabled = false;
            }
                sendDataToGTM({event: "payment_success", paymentValue: amount.current});
                //console.debug("Payment Success", paymentResults);
                console.log("Payment success");
                props.callback();
            } catch (e) {
                if ( cardButton != null){
                ((cardButton) as HTMLButtonElement).disabled = false;
            }
                console.log("Payment failure");
                sendDataToGTM({event: "payment_failed", paymentValue: amount.current});
                displayPaymentResults("FAILURE");
                //console.error(e.message);
            }
        }

        const cardButton = document.getElementById("card-button");
        if (cardButton != null)
        cardButton.addEventListener("click", async function (event) {
            // SCA only needs to be run for Card Payments. All other payment methods can be set to false.
            handlePaymentMethodSubmission(event, card, true);
        });
            // });
    }


    useEffect(() => {
        if (!loading) {
            console.log("loading");
            setLoading(true);
            buildForm();
        }
    }, [loading]);

    useEffect(() => {
        amount.current = props.amount;
        console.log("Square Amount changed " + props.amount);
    }, [props.amount])

    return (
        <>  
            {/* //@ts-ignore */}
            <Flex direction='column' alignItems='center' w='full' mt={4}>
                <Text textAlign='center' mb={4}>Please enter your card details:</Text>
                
                <Flex direction='row' justify='center'>
                    <form id="payment-form" className="flex justify-center flex-col">
                        <div id="card-container"></div>
                        <Button colorScheme={"blue"} id="card-button" type="submit" disabled={Number.isNaN(props.amount) || props.amount < 0.01 || props.billingContact === null}
                            isLoading={isInProgress} loadingText="Submitting  " spinnerPlacement='end' w='full'>
                            Pay £{props.amount.toFixed(2)}
                        </Button>
                    </form>
                </Flex>
                <Box paddingTop={"2%"}>
                    <Image src={AcceptedCardImage2} alt='Accepted payment methods' w={200} mb={2} paddingBottom={"1%"}/> {/* was w=294*/}
                </Box>
            </Flex>
            <Flex direction='column' justify='center' mt={4}>
                {isSuccess && 
                    <Alert status='success'>
                        <AlertIcon/>
                        <Box>
                            <AlertTitle>Payment Successful</AlertTitle>
                            <AlertDescription>You made a payment of £{previousPayment.toFixed(2)}</AlertDescription>
                        </Box>
                    </Alert>
                }
                {isError &&
                    <Alert status='error'>
                        <AlertIcon/>
                        <Box>
                            <AlertTitle>{errorMsg}</AlertTitle>
                            <AlertDescription>Check your details and try again, or contact us for further help.</AlertDescription>
                        </Box>
                    </Alert>
                }
            </Flex>
        </>
    )
}